import { useState } from 'react'
// import { useSelector } from 'react-redux'
import SocialButton from '../../components/SocialButton'
import Embellishment from '../../components/Embellishment'
import Label from '../../components/Label'
import Page from '../../components/Page'
import Prompt from '../../components/Prompt'
import Container from '@mui/material/Container'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Link from '@mui/material/Link'
import FormControl from '@mui/material/FormControl'
import Checkbox from '@mui/material/Checkbox'
import CircularProgress from '@mui/material/CircularProgress'
import useContentful from '../../contexts/useContentful'
import useMailchimp from '../../hooks/useMailchimp'
import useQualtricsSurvey from '../../hooks/useQualtricsSurvey'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
// import useRecaptcha from '../../hooks/useRecaptcha'

const validateEmail = email => {
  const emailRegex = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/
  return emailRegex.test(email)
}

const ThankYouPage = () => {
  const {
    title,
    description,
    buttonText,
    inputLabel,
    shareLabel,
    checkboxLabel,
    successLabel,
    joinListLabel,
    giveawayLinkText,
    giveawayLinkUrl,
    emailSubject,
    emailBody,
    twitterText,
    shareUrl,
    endSurveyPageHeader,
    endSurveyResults,
  } = useContentful()
  const { 
    createEmailSurveySession,
    submitSingleEmailAnswer,
    // completeEmailSurvey,
  } = useQualtricsSurvey()
  const [formData, setFormData] = useState({})
  const [consent, setConsent] = useState(false)
  const [isQualtricsLoading, setIsQualtricsLoading] = useState(false)
  const [qualtricsSuccess, setQualtricsSuccess] = useState(false)
  const [qualtricsSubmitted, setQualtricsSubmitted] = useState(false)
  const { subscribe, status, message } = useMailchimp('https://utah.us14.list-manage.com/subscribe/post?u=b5b8c7032970fbce415a7376a&amp;id=5a4e04151f&amp;f_id=008a71e0f0')
  const isButtonDisabled = !validateEmail(formData.EMAIL) || status === 'loading' || status === 'success' || isQualtricsLoading || qualtricsSuccess
  // const realIp = useSelector(({ global }) => global.realIp)
  // const { executeRecaptcha } = useRecaptcha();

  const handleSubmit = async e => {
    e.preventDefault()
    if(!qualtricsSubmitted){
      setIsQualtricsLoading(true)
      // const response = await executeRecaptcha("demographics")
      createEmailSurveySession(sesh => {
        submitSingleEmailAnswer(
          sesh, 
          'QID1', 
          formData.EMAIL
          // response?.score
        )
        setIsQualtricsLoading(false)
        setQualtricsSuccess(true)
        setQualtricsSubmitted(true)
      })
    }
    if (consent) subscribe(formData)
  }

  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  return (
    <Page>
      <Stack
        minHeight="calc(100% - 115px)"
      >
        <Container
          sx={{
            zIndex: 1,
            minHeight: '100%',
          }}
        >
          <Stack
            display="grid"
            py={6}
            minHeight="100%"
          >
            <Stack
              gap={2}
            >
              <Typography
                variant="h1Large"
                color="text.neutralDark"
                maxWidth="720px"
              >
                {endSurveyPageHeader}
              </Typography>
              <Typography
                variant="subtitle1"
                color="text.neutralDark"
                maxWidth="650px"
                sx={theme => ({
                  'a': {
                    textDecoration: 'underline !important',
                    color: theme.palette.text.neutralDark,
                    transition: theme.transitions.create(['color']),
                    '&:hover': {
                      color: theme.palette.text.neutralDark,
                    },
                  },
                })}
              >
                {documentToReactComponents(endSurveyResults)}
              </Typography>
            </Stack>
            {/* <Typography
              variant="h1"
              color="text.neutralDark"
              maxWidth="720px"
              mb={2}
            >
              {title}
            </Typography>
            <Typography
              variant="subtitle1"
              color="text.neutralDark"
              maxWidth="650px"
              mb={2.5}
            >
              {description}
            </Typography>
            <Stack
              gap={3}
              maxWidth="400px"
              mb={4}
            >
              <form 
                onSubmit={handleSubmit}
              >
                <Stack
                  gap={1.5}
                >
                  <Stack
                    gap={.5}
                  >
                    <Typography
                      variant="label"
                      color="text.neutralDark"
                    >
                      {inputLabel}
                    </Typography>
                    <TextField
                      name="EMAIL"
                      onChange={handleChange}
                    />
                  </Stack>
                  <FormControl 
                    component="fieldset"
                    sx={{
                      display: 'grid',
                      gridTemplateColumns: 'auto 1fr',
                      gap: 1,
                      alignItems: 'center',
                    }}
                  >
                    <Checkbox
                      checked={consent}
                      onChange={() => {
                        setConsent(!consent)
                        qualtricsSubmitted && setQualtricsSuccess(false)
                      }}
                    />
                    <Label
                      variant="label"
                    >
                      {checkboxLabel}
                    </Label>
                  </FormControl>
                  <Button
                    type="submit"
                    sx={{
                      position: 'relative',
                    }}
                    disabled={isButtonDisabled}
                    onClick={handleSubmit}
                  >
                    <span
                      style={{
                        opacity: status === 'loading' || isQualtricsLoading ? 0 : 1,
                      }}
                    >
                      {status === 'success' || qualtricsSuccess && !isQualtricsLoading ? successLabel : qualtricsSubmitted ? joinListLabel : buttonText}
                    </span>
                    {(status === 'loading' || isQualtricsLoading) && (
                      <CircularProgress
                        size={25}
                        sx={{
                          position: 'absolute',
                        }}
                      />
                    )}
                  </Button>
                  {!!message?.length && status === 'error' && (
                    <Typography
                      color="error"
                    >
                      {message}
                    </Typography>
                  )}
                  <Link
                    color="secondary"
                    textAlign="center"
                    href={giveawayLinkUrl} 
                    target="_blank"
                  >
                    {giveawayLinkText}
                  </Link>
                </Stack>
              </form>
            </Stack> */}
            <Stack
              display="grid"
              gridAutoFlow={{
                sm: 'column',
              }}
              justifyContent="flex-start"
              alignItems="center"
              alignSelf="flex-end"
              gap={1.5}
            >
              <Typography
                variant="subtitle2"
              >
                {shareLabel}
              </Typography>
              <Stack
                display="grid"
                gridAutoFlow="column"
                justifyContent="flex-start"
                alignItems="center"
                gap={1.5}
              >
                <SocialButton
                  type="twitter"
                  subject={twitterText}
                  url={shareUrl}
                />
                <SocialButton
                  type="facebook"
                  url={shareUrl}
                />
                <SocialButton
                  type="linkedin"
                  url={shareUrl}
                />
                <SocialButton
                  type="email"
                  subject={emailSubject}
                  body={emailBody}
                />
                {/* <SocialButton
                  type="hyperlink"
                /> */}
              </Stack>
            </Stack>
          </Stack>
        </Container>
        <Embellishment />
      </Stack>
      <Prompt /> 
    </Page>
  )
}

export default ThankYouPage
